<!-- Shell (title bar + close button + footer bar) comes from cm-ui-dialog — this
     component only supplies the body and the two footer slots. -->
<cm-ui-dialog
  [title]="'ADMIN.medialibrary.mergePreview.title' | translate"
  [closeLabel]="'common.close' | translate">

  <div class="mp-body">

    <!-- Preview: the capability URL is bound verbatim; a media element cannot carry a
         Bearer header, which is exactly why the backend mints `?key=`. -->
    <div class="mp-preview">
      @if (previewUrl) {
        <video class="mp-video" controls preload="metadata" [src]="previewUrl"></video>
      } @else {
        <div class="mp-video-missing">
          <mat-icon>videocam_off</mat-icon>
          <span>{{ 'ADMIN.medialibrary.mergePreview.previewUnavailable' | translate }}</span>
        </div>
      }

      <div class="mp-facts">
        <div class="mp-fact">
          <span class="mp-fact-label">{{ 'ADMIN.medialibrary.mergePreview.duration' | translate }}</span>
          <span class="mp-fact-value">{{ formattedDuration() }}</span>
        </div>
        <div class="mp-fact">
          <span class="mp-fact-label">{{ 'ADMIN.medialibrary.mergePreview.resolution' | translate }}</span>
          <span class="mp-fact-value">{{ formattedResolution() }}</span>
        </div>
        <div class="mp-fact">
          <span class="mp-fact-label">{{ 'ADMIN.medialibrary.mergePreview.fileSize' | translate }}</span>
          <span class="mp-fact-value">{{ formattedSize() }}</span>
        </div>
      </div>
    </div>

    <!-- Everything the user still gets to decide before the draft becomes an asset. -->
    <div class="mp-form">
      <cm-ui-chip
        class="mp-chip"
        size="sm"
        tone="warning"
        icon="hourglass_empty"
        [label]="'ADMIN.medialibrary.mergePreview.draft' | translate"
      />

      <div class="mp-field">
        <label for="mp-name">{{ 'ADMIN.medialibrary.mergePreview.name' | translate }}</label>
        <input
          id="mp-name"
          type="text"
          [ngModel]="name()"
          (ngModelChange)="name.set($event)"
          [placeholder]="'ADMIN.medialibrary.mergePreview.namePlaceholder' | translate" />
      </div>

      <!-- Read-only: createdBy is resolved from the confirming user's JWT server-side. -->
      <div class="mp-field">
        <span class="mp-field-label">{{ 'ADMIN.medialibrary.mergePreview.owner' | translate }}</span>
        <div class="mp-owner">
          <mat-icon>person</mat-icon>
          <span>{{ ownerName() }}</span>
        </div>
        <span class="mp-hint">{{ 'ADMIN.medialibrary.mergePreview.ownerHint' | translate }}</span>
      </div>

      <div class="mp-field">
        <span class="mp-field-label">{{ 'ADMIN.medialibrary.mergePreview.labels' | translate }}</span>

        @if (labelGroups().length === 0) {
          <span class="mp-hint">{{ 'ADMIN.medialibrary.mergePreview.noLabels' | translate }}</span>
        }

        @for (group of labelGroups(); track group.definition.uuid) {
          <div class="mp-label-group">
            <span class="mp-group-name">{{ group.definition.name }}</span>
            <div class="mp-label-options">
              @for (label of group.labels; track label.uuid) {
                <cm-ui-standard-button
                  outlined
                  [active]="isSelected(label.uuid)"
                  [icon]="isSelected(label.uuid) ? 'check' : undefined"
                  (onClick)="toggleLabel(group, label)">
                  @if (group.definition.renderType === 'COLOR') {
                    <app-label-chip [label]="label" />
                  }
                  {{ label.name }}
                </cm-ui-standard-button>
              }
            </div>
          </div>
        }
      </div>

      @if (showCompliance()) {
        <div class="mp-field mp-compliance">
          <span class="mp-field-label">
            {{ 'ADMIN.medialibrary.mergePreview.compliance' | translate }}
            <mat-icon class="mp-lock" [matTooltip]="'ADMIN.medialibrary.mergePreview.complianceLocked' | translate">lock</mat-icon>
          </span>
          <cm-ui-chip class="mp-chip" size="sm" tone="warning" [label]="complianceStatusName" />
          <span class="mp-hint">{{ 'ADMIN.medialibrary.mergePreview.complianceHint' | translate }}</span>
        </div>
      }
    </div>
  </div>

  <ng-container footer-left>
    <cm-ui-standard-button rounded [disabled]="saving()" (onClick)="cancel()">
      {{ 'ADMIN.medialibrary.mergePreview.discard' | translate }}
    </cm-ui-standard-button>
  </ng-container>
  <ng-container footer-right>
    <cm-ui-standard-button
      rounded
      green
      icon="save"
      [disabled]="!canSave()"
      (onClick)="save()">
      {{ 'ADMIN.medialibrary.mergePreview.save' | translate }}
    </cm-ui-standard-button>
  </ng-container>

</cm-ui-dialog>
